module.exports = __webpack_public_path__ + "fb41a6e5d8c84e6b93b70b4c70175108.fbx";